import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'next/router'
import { inject, observer } from 'mobx-react/index'

import Layout from '../components/Layout'
import Footer from '../components/Footer'

import { withTranslation, i18n } from '../i18n'

import { Container, Heading } from '../styles/listsStyles'
import PodcastItem from '../components/PodcastItem'
import { fetchOnePodcast } from '../api/podcasts'

export const redirectByEnLang = (lang, routerFunc) => {
  if (lang === 'en') {
    routerFunc('/')
  }
}
@inject('store')
@observer
class Podcast extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    currentLanguage: PropTypes.string.isRequired,
    store: PropTypes.instanceOf(Object).isRequired,
    router: PropTypes.instanceOf(Object).isRequired,
    podcast: PropTypes.instanceOf(Object).isRequired
  }

  static async getInitialProps({ req }) {
    const currentLanguage = req ? req.language : i18n.language
    const podcast = await fetchOnePodcast(currentLanguage)
    return {
      namespacesRequired: ['podcasts', 'common', 'auth', 'reset-password', 'contacts', 'about', 'artists'],
      currentLanguage,
      podcast
    }
  }

  componentDidMount() {
    redirectByEnLang(this.props.currentLanguage, this.props.router.replace)
  }

  componentDidUpdate() {
    redirectByEnLang(this.props.currentLanguage, this.props.router.replace)
  }

  render() {
    const {
      t,
      podcast,
      currentLanguage
    } = this.props

    return (
      <Layout
        meta={{ title: podcast.name, image: podcast.image, description: podcast.description }}
        coverImageUrl="podcast-cover"
        currentLanguage={currentLanguage}
      >
        <Container>
          <div className="content podcasts-content">
            <Heading>{t('common:PAGE_PODCAST_TITLE')}</Heading>
            <PodcastItem podcast={podcast} />
          </div>
        </Container>
        <Footer />
      </Layout>
    )
  }
}

const WithRouter = withRouter(Podcast)
export default withTranslation(
  ['podcasts', 'common', 'auth', 'reset-password', 'contacts', 'about', 'artists'])(WithRouter)
